export default {
    readAccess: 'Read Access',
    logsList: 'Logs List',
    accessReason: 'Access Reason',
    createdBy: 'Created By',
};
